import { CASES } from './constants';

export const updateDateMathCalculations = (payload) => {
    return { type: CASES.UPDATE_DATE_MATH_CALCULATIONS, payload };
};

export const updateDateMathCalculationsSearchForm = ({ key, data }) => {
    return {
        type: CASES.UPDATE_DATE_MATH_CALCULATIONS_SEARCH_FORM,
        payload: { key, data },
    };
};

export const clearDateMathCalculations = () => {
    return { type: CASES.CLEAR_DATE_MATH_CALCULATIONS, payload: {} };
};
